export default "__VITE_PUBLIC_ASSET__d0b2b007__"